import { CONFIG_COGNITO_SHOPIFY_MULTIPASS_TOKEN_ENDPOINT } from '@src/config/env'
import { getUserSession } from '../utils'
import customerAccessTokenCreateWithMultipass from './customerAccessTokenCreateWithMultipass'
import axios from 'axios'

const multipassTokenFetchURL = CONFIG_COGNITO_SHOPIFY_MULTIPASS_TOKEN_ENDPOINT

const fetchCustomerAccessToken = async client => {
  const userSession = await getUserSession()
  if (!userSession?.idToken?.jwtToken) return null

  const multipassFetch = await axios.get(multipassTokenFetchURL, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: userSession.idToken.jwtToken,
    },
  })
  const multipassToken = multipassFetch.data

  const accessTokenResult = await customerAccessTokenCreateWithMultipass(client, {
    multipassToken,
  })

  const {
    data: {
      customerAccessTokenCreateWithMultipass: { customerAccessToken },
    },
  } = accessTokenResult

  return customerAccessToken
}

export default fetchCustomerAccessToken
